import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const GradientTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%)',
        overflow: 'hidden', fontFamily: 'Arial, sans-serif',
        position: 'relative', boxSizing: 'border-box'
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.15) 0%, transparent 50%)', opacity: 0.8 }} />
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.12) 0%, transparent 50%)', opacity: 0.7 }} />

      <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '100px 80px 80px 80px', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ display: 'inline-block', padding: '30px', background: 'rgba(255, 255, 255, 0.25)', backdropFilter: 'blur(20px)', borderRadius: '50%', border: '2px solid rgba(255, 255, 255, 0.5)', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)' }}>
            <svg width="160" height="160" viewBox="0 0 24 24" fill="none">
              {/* 移除 inline filter style，改用 SVG drop-shadow filter */}
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                fill="#ffffff"
              />
            </svg>
          </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: '240px', fontWeight: '800', color: '#ffffff', lineHeight: '1', marginBottom: '30px', fontFamily: 'Arial, sans-serif', letterSpacing: '-5px', textShadow: '0 10px 30px rgba(0, 0, 0, 0.3)' }}>{calculatedDays}</div>
          <div style={{ fontSize: '50px', fontWeight: '600', color: '#ffffff', marginBottom: '60px', textShadow: '0 5px 20px rgba(0, 0, 0, 0.25)' }}>{language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}</div>
          {detailedTime && (<div style={{ fontSize: '38px', color: '#ffffff', fontWeight: '500', marginBottom: '40px', padding: '20px 50px', background: 'rgba(255, 255, 255, 0.25)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.4)', borderRadius: '60px', display: 'inline-block', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)' }}>{formatDetailedTime(detailedTime, language)}</div>)}
          {quote && (<div style={{ fontSize: '32px', color: '#ffffff', fontStyle: 'italic', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto', textShadow: '0 5px 20px rgba(0, 0, 0, 0.3)' }}>"{quote}"</div>)}
        </div>

        <div style={{ textAlign: 'center', background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255, 255, 255, 0.35)', borderRadius: '30px', padding: '30px 40px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)' }}>
          {anniversaryDate && (<div style={{ fontSize: '30px', color: '#ffffff', marginBottom: '15px', textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}>{formatDate(anniversaryDate, language)}</div>)}
          <div style={{ fontSize: '36px', fontWeight: '700', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '10px', textShadow: '0 5px 20px rgba(0, 0, 0, 0.25)' }}>{getBrandingText(anniversaryType, language)}</div>
          <div style={{ fontSize: '26px', color: '#ffffff', opacity: 0.95, textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}>lovedays.homy.hk</div>
        </div>
      </div>
    </div>
  );
};

export default GradientTemplate;